import { jsx as _jsx } from "react/jsx-runtime";
import { useSignals } from '@preact/signals-react/runtime';
import TagsPanel from 'components/TagsPanel';
import { useEditorContext } from '../../contexts/projectSignal';
import styles from './style.module.less';
const TagsSection = ({ onProjectUpdate, isLocked }) => {
    const { projectSignal } = useEditorContext();
    // FIXME: @EvaMach Check after changes to access token if we really need to track whole project.
    useSignals();
    const project = projectSignal.value;
    return (_jsx("div", { className: styles.projectMenuTags, children: _jsx("div", { className: styles.projectMenuTagsSection, children: _jsx(TagsPanel, { project: project, projectTags: project.tags, enqueueProjectUpdate: onProjectUpdate, isLocked: isLocked }) }) }));
};
export default TagsSection;
